import { RequestDto } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

import { BP42SubmitResult } from '@r1-frontend/bp42/actions/thunk/submit';
import { BP42ViewDetails } from '@r1-frontend/bp42/selectors/getViewDetails';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { TField } from '@r1-frontend/ui-react/organisms/Forms/NamePhoneForm';
import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

export interface BP42InitialState {
    /**
     * Флаг подтверждающий пройденную инициализацию
     */
    _initialized: boolean,

    /**
     * Флаг состояния обработки запроса
     */
    _loading: boolean,

    /**
     * Данные для попапа
     */
    _popup: {
        open: boolean,
    },

    /**
     * Пользователь начал ввод данных в форму
     */
    _startedTyping: boolean,

    /**
     * Номер договора для передачи в аналитику
     */
    _uid?: number,

    /**
     * Результат обработки запроса к `requestByConnection`
     */
    _submitResult: BP42SubmitResult,

    /**
     * Необходимость показать спец. предложение, после начала ввода в форму
     */
    needToShowSpecialOffer: boolean,

    /**
     * Необходимость показать результирующий попап с успехом или провалом запроса создания обратного звонка
     */
    needToShowResponseResult: boolean,

    /**
     * Имя пакета (необходимо для аналитики)
     */
    packageName: string,

    /**
     * Список выбранных продуктов
     */
    selectedProducts: EProductsId[],

    /**
     * Данные формы
     */
    formData: {
        name: Omit<TField, 'clearInput'>,
        phone: Omit<TField, 'clearInput'>,
    },

    /**
     * Доп. данные для запроса к методу БП42 (requestByConnection)
     */
    requestDataParams: Omit<RequestDto, 'product_id' | 'fio' | 'phone' | 'domain' | 'ga_cid' | 'check_call_type' | 'csrf'>,

    /**
     * Данные отображения
     */
    viewDetails?: BP42ViewDetails,
}

export type BP42IncomingData = Omit<BP42InitialState, '_loading' | '_initialized' | '_popup' | '_startedTyping' | '_uid' | '_submitResult'>

const initialState: BP42InitialState = {
    _initialized: false,
    _loading: false,
    _popup: {
        open: false,
    },
    _startedTyping: false,
    _uid: undefined,

    _submitResult: {
        ok: undefined,
        message: '',
        status: EResultPopupStatus.SUCCESS,
    },

    needToShowResponseResult: false,
    needToShowSpecialOffer: false,

    packageName: 'Неизвестный пакет',
    selectedProducts: [],

    formData: {
        name: { value: '', isValid: false },
        phone: { value: '', isValid: false },
    },

    requestDataParams: {},

    viewDetails: {},
};

export default initialState;
